module.exports = __webpack_public_path__ + "img/antes_despues_317.053894e4.png";